import React, { Component } from "react";
import {
    Panel,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Button,
    InputGroup
} from "react-bootstrap";
import {
    ToastContainer,
    toast
}                           from "react-toastify";

import {
    IS_VALID
} from "utils";

export default class EasyPromosCustomURL extends Component {
    constructor (props) {
        super(props);

        this.state = {
            url: "",
            output: "",
			mobileAppDeepLink: 'epicrewardsapp',
        };

        this.generate = this.generate.bind(this);
    }

	componentDidMount() {
		Parse.Config.get()
        .then((config) => {
            this.setState({
                mobileAppDeepLink: config.get("MOBILE_APP_DEEP_LINK") || 'epicrewardsapp'
            });
        })
        .catch((err) => {
            console.log(err);
        });
	}

    generate () {
        let {
            url,
            mobileAppDeepLink
        } = this.state;

        if (
            !IS_VALID(url.trim())
        ) {
            toast.error("URL is required.");
        } else {
            let splitted = url.split("/");

            this.setState({
                output: `${mobileAppDeepLink}://easypromos/${splitted[splitted.length-1]}`
            });
        }
    }

    render () {
        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4>EasyPromos Custom URL</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col mdOffset={4} md={4}>
                                <FormGroup>
                                    <ControlLabel>
                                        URL
                                    </ControlLabel>
                                    <FormControl
                                        value={this.state.url}
                                        onChange={(e) => {
                                            this.setState({
                                                url: e.target.value
                                            });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{ textAlign: "center" }}>
                                <Button
                                    bsStyle="primary"
                                    onClick={this.generate}
                                >
                                    Generate
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col mdOffset={4} md={4}>
                                <FormGroup>
                                    <ControlLabel>
                                        Output
                                    </ControlLabel>
                                    <InputGroup>
                                        <FormControl
                                            value={this.state.output}
                                            readOnly
                                        />
                                        <InputGroup.Button>
                                            <Button
                                                onClick={() => {
                                                    navigator.clipboard.writeText(this.state.output);
                                                }}
                                            >
                                                <i
                                                    className="fa fa-copy"
                                                />
                                            </Button>
                                        </InputGroup.Button>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Panel.Body>
                </Panel>
                <ToastContainer/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/EasyPromosCustomURL/index.js